export const TEXT = 'text';
export const MASKTEXT = 'masktext';
export const MULTILINE = 'multiline';
export const TEXT_EDITOR = 'textEditor';
export const SCRIPT = 'script';
